import { useQuery } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { AxiosResponse } from "axios";
import { IDirectoryEntry } from "../types/DirectoryEntry";
import { injectDirectoryEntryTypeIntoProfile } from "../helpers/directoryEntry";

interface IOptions {
  enabled?: boolean;
}

export const useCrmDirectoryEntry = (directoryId: string | undefined, options: IOptions = { enabled: true }) => {
  const crmApi = makeCRMApi();

  const crmDirectoryEntry = useQuery<AxiosResponse<IDirectoryEntry>>({
    queryKey: ['crm-directory-entry', directoryId],
    queryFn: () => crmApi.getDirectoryEntry(directoryId as string),
    enabled: !!options.enabled && !!directoryId,
  });

  const directoryEntry = !crmDirectoryEntry.data?.data ? undefined : {
    ...crmDirectoryEntry.data?.data,
    profile: injectDirectoryEntryTypeIntoProfile(crmDirectoryEntry.data?.data),
  };

  return {
    crmDirectoryEntryResponse: crmDirectoryEntry,
    directoryEntry,
  };
}
